var _path, _rect, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path5, _path6, _rect25, _path7, _path8, _path9, _circle, _circle2, _circle3, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllShipments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 200,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.524 39.592L191.912 163.196C188.213 166.816 183.178 168.849 177.942 168.857H9.85832C4.43712 168.823 0 164.457 0 159.165C0 156.634 1.01922 154.198 2.82921 152.388L121.006 37.3618C124.696 33.6305 129.748 31.4689 135.064 31.3574H315.097C317.786 31.366 320 33.5361 320 36.1609C320 37.4476 319.464 38.6913 318.524 39.592Z",
    fill: "#E8EFF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 51,
    width: 88,
    height: 56,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147 47H145V55H147L147 49L153 49V47H147Z",
    fill: "#220C4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 109L145 111L153 111L153 109L145 109ZM147 109L147 103L145 103L145 109L147 109Z",
    fill: "#220C4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241 49L241 47L233 47L233 49L239 49L239 55L241 55L241 49Z",
    fill: "#220C4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 59,
    width: 2,
    height: 40,
    rx: 1,
    fill: "#220C4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 59,
    width: 4,
    height: 40,
    rx: 2,
    fill: "#220C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 59,
    width: 2,
    height: 40,
    rx: 1,
    fill: "#220C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 59,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#220C4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 59,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#220C4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 59,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#220C4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 59,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#220C4A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 59,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#220C4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 59,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#220C4A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 59,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#220C4A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 59,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#220C4A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 179.182,
    y: 70.6426,
    width: 70.7273,
    height: 57.6329,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 185.455,
    y: 76.8711,
    width: 58.1818,
    height: 48.7906,
    fill: "#F5F5F5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 107.591,
    width: 18.1818,
    height: 12.6494,
    fill: "#E0E0E0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 206.455,
    y: 70.6426,
    width: 16.1818,
    height: 16.0706,
    fill: "#CCCCCC",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 197.364,
    y: 126.662,
    width: 70.7273,
    height: 57.6329,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 203.636,
    y: 132.891,
    width: 58.1818,
    height: 48.7906,
    fill: "#F5F5F5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 238.182,
    y: 163.61,
    width: 18.1818,
    height: 12.6494,
    fill: "#E0E0E0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 224.636,
    y: 126.662,
    width: 16.1818,
    height: 16.0706,
    fill: "#CCCCCC",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128.273,
    y: 126.662,
    width: 70.7273,
    height: 57.6329,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 134.545,
    y: 132.891,
    width: 58.1818,
    height: 48.7906,
    fill: "#F5F5F5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 169.091,
    y: 163.61,
    width: 18.1818,
    height: 12.6494,
    fill: "#E0E0E0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 155.545,
    y: 126.662,
    width: 16.1818,
    height: 16.0706,
    fill: "#CCCCCC",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0765 81.8172C68.0781 77.8107 71.678 75 75.8078 75H118.877C120.829 75 122.261 76.8342 121.787 78.7276L116.924 98.1828C115.922 102.189 112.322 105 108.192 105H65.1231C63.1714 105 61.7393 103.166 62.2127 101.272L67.0765 81.8172Z",
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105H110V112C110 113.657 108.657 115 107 115H68C66.3431 115 65 113.657 65 112V105Z",
    fill: "#E0E0E0",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 104,
    width: 4,
    height: 2,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2393 150L68.8069 115H90.7607L83.1931 150H61.2393Z",
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 153C60 151.343 61.3431 150 63 150H87C88.6569 150 90 151.343 90 153V161C90 162.657 88.6569 164 87 164H63C61.3431 164 60 162.657 60 161V153Z",
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78 131.5C80.8 125.5 80.5 118.667 80 116V115H69L62.5 145H70C71.5 143 75.2 137.5 78 131.5Z",
    fill: "#CCCCCC",
    stroke: "#220C4A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 82,
    r: 2,
    fill: "#220C4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 82,
    r: 2,
    fill: "#220C4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 82,
    r: 2,
    fill: "#220C4A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 89,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 99,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 96,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 144 96)",
    fill: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 96,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 134 96)",
    fill: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 47,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#CCCCCC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 57,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 54,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 140 54)",
    fill: "#CCCCCC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 54,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 130 54)",
    fill: "#CCCCCC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 107,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#CCCCCC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 117,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#CCCCCC"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 114,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 129 114)",
    fill: "#CCCCCC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 114,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(90 119 114)",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllShipments);
export default __webpack_public_path__ + "static/media/all-shipments.45529d9f5ea911c82531f435691c3c2c.svg";
export { ForwardRef as ReactComponent };